import(/* webpackMode: "eager", webpackExports: ["ToolSkeleton"] */ "/vercel/path0/components/ui/ToolSkeleton.tsx");
